module.exports = __webpack_public_path__ + "static/media/berlin_construction_lady.1a0adda4.jpg";